import React, { useRef } from "react";
import { FullScreenModal } from "../UI/Modal";
import { Label } from "../UI/styles";
import { translate } from "../../utils/translations/translate";
import Button from "../UI/Button";
import { StyledApprovalModal } from "./styles";
const modalMessagesMapping = {
    "approved":{
        title:translate('labels.approveTimesheet'),
        info:translate('labels.approveTimesheetInfo'),
        textAreaLabel:translate('labels.approvalTimesheetCmntLabel')
    },
    "rejected":{
        title:translate('labels.rejectTimesheet'),
        info:translate('labels.rejectTimesheetInfo'),
        textAreaLabel:translate('labels.rejectTimesheetCmntLabel')
    }
}
export const TimesheetApprovalModal = ({ ids, action, onConfirm, onClose }) => {
  const commentBoxRef = useRef();
  const {title,info,textAreaLabel} = modalMessagesMapping[action?.toLowerCase()] || {};
  const handleConfirm = () => {
    const isRejectModal = action?.toLowerCase() === "rejected";
    const commentsProvided = commentBoxRef.current?.value;
    if(isRejectModal && !commentsProvided){
        commentBoxRef.current?.focus();
        return false;
    }
    onConfirm({ ids, action, comments: commentBoxRef.current?.value });
  };
  return (
    <FullScreenModal preventBackdropClick={true} onClose={onClose}>
      <StyledApprovalModal>
        <h1 className="tma_modal_title">{title}</h1>
        <p className="tma_modal_info">{info}</p>
        <div className={'tma_approver_comment_section'}>
          <Label>{textAreaLabel}</Label>
          <textarea rows={6} cols={40} ref={commentBoxRef}></textarea>
        </div>
        <div className="tma_modal_actions">
          <Button
            onClick={onClose}
            className="tma_cancel_btn primary-outline"
            text={translate("labels.cancel")}
          />
          <Button
            onClick={handleConfirm}
            variantStyle="primary"
            className="tma_confirm_btn"
            text={translate("labels.confirm")}
          />
        </div>
      </StyledApprovalModal>
    </FullScreenModal>
  );
};
